import React, { useEffect, useState } from 'react';
import GmModal from 'app/shared/modal/modal';
import styles from '../view.module.css';

export const ContentJobRejectModal = ({ show, onClose, onSubmit, submitting = false }) => {
  const [rejection_comment, setRejectionComment] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!show) {
      setRejectionComment('');
      setError('');
    }
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const cleaned_comment = rejection_comment.trim();

    if (!cleaned_comment) {
      setError('Tell the agent what to change — the comment is required.');
      return;
    }

    setError('');
    const success = await onSubmit(cleaned_comment);
    if (success) onClose();
  };

  return (
    <GmModal
      title="Reject this draft"
      show_title
      show_modal={show}
      onClose={onClose}
      bodyClassName={styles.rejectModal}
    >
      <form className={styles.rejectForm} onSubmit={handleSubmit}>
        <label className={styles.rejectLabel} htmlFor="content-job-rejection-comment">
          What should change?
        </label>
        <textarea
          id="content-job-rejection-comment"
          className={styles.rejectInput}
          value={rejection_comment}
          onChange={(e) => {
            setRejectionComment(e.target.value);
            if (error) setError('');
          }}
          placeholder="e.g. Too salesy in the tease"
          rows={4}
          autoFocus
        />
        <p className={styles.rejectNote}>
          The comment is stamped onto this version and the agent writes a new one. Nothing is
          deleted.
        </p>
        {error && <div className={styles.rejectError}>{error}</div>}

        <div className={styles.rejectActions}>
          <button
            type="button"
            className={styles.rejectCancelBtn}
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button type="submit" className={styles.rejectSubmitBtn} disabled={submitting}>
            {submitting ? 'Submitting…' : 'Reject and regenerate'}
          </button>
        </div>
      </form>
    </GmModal>
  );
};
